// import React, { useEffect, useState } from 'react';
// import { useForm, Controller } from "react-hook-form";
// import { useSnackbar } from 'notistack';
// import {
//     TextField,
//     Button,
//     FormControl,
//     DialogActions,
//     InputAdornment,
//     Select,
//     MenuItem
// } from '@mui/material';
// import _ from 'lodash';
// import axios from "axios";

// import Loader from 'components/Loader';
// import { countryCode } from 'constants/appData/filters';
// import axiosInstance from "configs/axiosConfig";
// import { APIRouteConstants, dashboardRouteConstants } from "constants/routeConstants";
// import CustomDialog from 'components/Dialog';
// import { handleOpenAuthDialog, updateUserDetail } from 'utils/auth';
// import { API_URL, GLOBAL_COUNTRY_CODE } from 'constants/appConstants'
// import Forgotpassword from 'containers/Forgotpassword';
// import PrivacyPolicy from 'containers/PrivacyPolicy';
// import TermsAndConditions from 'containers/TermsAndConditions';

// export default function AuthDialog({ isAuthDialogOpen, setAuthDialog, refreshUser, logoUrl }) {
//     const { register, formState: { errors }, handleSubmit, control, getValues } = useForm({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             mobile_number: '',
//             email: '',
//             password: '',
//             country_code: GLOBAL_COUNTRY_CODE
//         },
//     });
//     const { enqueueSnackbar } = useSnackbar();
//     const [isLoginView, setLoginView] = useState(true);
//     const [loader, setLoader] = useState(false);
//     const [isForgotPass, setIsForgotPass] = useState(false)
//     const [isOpenPrivacy, setOpenPrivacy] = useState(false)
//     const [isOpenTerms, setOpenTerms] = useState(false)

//     const handleLoginView = () => {
//         if (isForgotPass) {
//             setIsForgotPass(false)
//             setLoginView(true)
//         } else {
//             setLoginView(!isLoginView)
//         }
//     }

//     const DialogHeader = (
//         <span className='description'>Please enter your details to {isLoginView ? 'sign in' : 'get started'}.</span>
//     );

//     const DialogAction = (
//         <Button type="submit" color="success" variant="contained">
//             {isLoginView ? 'Sign in' : 'Sign up'}
//         </Button>
//     )

//     const DialogFooter = (
//         <div style={{ textAlign: 'center' }} className='link-wrapper'>
//             <u onClick={handleLoginView}>
//                 <p className="decorated-text description">
//                     {isLoginView && !isForgotPass ?
//                         `Don't have an account? Create account` :
//                         `Already an existing user? Sign in`}
//                 </p>
//             </u>
//         </div>
//     )

//     const privacyStatement = (
//         <div style={{ textAlign: 'center', padding: '0.6rem 2rem' }} className=' link-wrapper'>
//             <u>
//                 <p style={{ fontSize: '15px', }} className="description">
//                     By continuing, you agree to the
//                     <span
//                         className='link-wrapper-underLine'
//                         onClick={() => setOpenTerms(true)}>
//                     {" "} Terms of Service
//                     </span> and  <span
//                     onClick={(e) => {
//                         setOpenPrivacy(true)
//                     }} className='link-wrapper-underLine'>Privacy Policy.</span>
//                 </p>
//             </u>
//         </div>
//     )

//     const getUser = async (token) => {
//         let res = await axios.get(APIRouteConstants.AUTH.ME, {
//             baseURL: API_URL,
//             headers: {
//                 Accept: "application/json",
//                 "domain-name": 'accessories',
//                 Authorization: `Bearer ${token}`,
//             }
//         })
//         let { data, response } = res;

//         if (response
//             && response.status === 401) {
//             // navigate(authRouteConstants.LOGOUT)
//         }

//         if (data && data.success) {
//             const user = data.data;
//             updateUserDetail(user)
//             handleOpenAuthDialog()
//             setLoader(false)
//         }
//     }

//     const doLogin = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.LOGIN, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data) {
//             if (response.data.message) {
//                 enqueueSnackbar(response.data.message, { variant: 'error' });
//                 setLoader(false)
//             } else
//                 for (let i in response.data) {
//                     enqueueSnackbar(response.data[i][0], { variant: 'error' });
//                     setLoader(false)
//                 }
//         }

//         if (data && data.success) {
//             localStorage.setItem('u-access-token', data.access)
//             getUser(data.access)
//         }
//     }

//     const doCreateUser = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.SIGNUP, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data ) {
//                 if (response.data.message) {
//                     enqueueSnackbar(response.data.message, { variant: 'error' })
//                 } else {
//                     for (let i in response.data) {
//                         enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
//                     }
//                 }
//         }

//         if (!_.isEmpty(data)) {
//             setLoginView(true)
//         }
//         setLoader(false)
//     }

//     const handleAuth = (formData) => {
//         if (isLoginView) doLogin(formData)
//         else {
//             if (formData.mobile_number) {
//                 formData = {
//                     ...formData,
//                     country_code: formData.country_code.dial_code,
//                 }
//             } else {
//                 delete formData['mobile_number']
//                 delete formData['country_code']
//             }
//             doCreateUser(formData)
//         }
//     }

//     const openTermsAndConditions = (value) => {
//         setOpenTerms(value);
//     }

//     const openPrivacyPolicy = (value) => {
//         setOpenPrivacy(value);
//     }

//     return (
//         <div>
//             <CustomDialog
//                 isDialogOpen={isAuthDialogOpen}
//                 setDialogOpen={setAuthDialog}
//                 header={!isForgotPass && DialogHeader}
//                 footer={DialogFooter}
//                 isFormattedDialog={!isForgotPass}
//                 action={DialogAction}
//                 handleForm={handleAuth}
//                 logoUrl={logoUrl}
//                 subFooter={!isForgotPass && privacyStatement}
//             >
//                 <Loader open={loader} />
//                 {!isForgotPass ? (
//                     <div>
//                         {isLoginView ?
//                             <form onSubmit={handleSubmit(handleAuth)}>
//                                 <div className="dialog-body">
//                                     <div className='auth-wrapper form-wrapper'>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="email"
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("email", { required: true })}
//                                                 error={errors.email?.type}
//                                                 helperText={errors.email?.type === "required" && (
//                                                     'Email or Phone number is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="name"
//                                                 placeholder="Enter Password"
//                                                 type="password"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 // label="Password"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("password", { required: true })}
//                                                 error={errors.password?.type}
//                                                 helperText={errors.password?.type === "required" && (
//                                                     'Password is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                     </div>
//                                 </div>
//                                 <DialogActions className='dialog-action-wrapper'>
//                                     {DialogAction}
//                                 </DialogActions>
//                             </form>
//                             : <form onSubmit={handleSubmit(handleAuth)}>
//                                 <div className="dialog-body">
//                                     <div className='auth-wrapper form-wrapper'>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="first_name"
//                                                 placeholder="First Name"
//                                                 type="text"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("first_name", { required: true, maxLength: 20 })}
//                                                 error={errors.first_name?.type}
//                                                 helperText={errors.first_name?.type === "required" && (
//                                                     'First name is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="last_name"
//                                                 placeholder="Last Name"
//                                                 type="text"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("last_name", { required: true, maxLength: 20 })}
//                                                 error={errors.last_name?.type}
//                                                 helperText={errors.last_name?.type === "required" && (
//                                                     'Last name is required'
//                                                 )}
//                                             />
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="email"
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("email", { required: true, pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i })}
//                                                 error={errors.email?.type}
//                                                 helperText={(errors.email?.type === "required" && (
//                                                     'Email is required'
//                                                 ) || errors.email?.type === "pattern" && (
//                                                     'Email is invalid'
//                                                 ))}
//                                             />
//                                         </FormControl>
//                                         <FormControl fullWidth className='select-wrapper'>
//                                             <Controller
//                                                 control={control}
//                                                 name="mobile_number"
//                                                 rules={{ required: true, maxLength: 10, minLength: 10 }}
//                                                 // defaultValue={contact?.mobile_number}
//                                                 render={({ field: { onChange, value } }) => (
//                                                     <TextField
//                                                         margin="dense"
//                                                         id="name"
//                                                         placeholder="Mobile Number"
//                                                         type="text"
//                                                         fullWidth
//                                                         variant="outlined"
//                                                         size="small"
//                                                         onChange={onChange}
//                                                         value={value}
//                                                         autoComplete='false'
//                                                         InputLabelProps={{ shrink: false }}
//                                                         InputProps={{
//                                                             startAdornment: <InputAdornment position="start">
//                                                                 <Select
//                                                                     labelId="demo-simple-select-label"
//                                                                     id="demo-simple-select"
//                                                                     className="select-input"
//                                                                     label="Status"
//                                                                     size="small"
//                                                                     fullWidth
//                                                                     sx={{
//                                                                         ".MuiOutlinedInput-notchedOutline": { border: 0 },
//                                                                         "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                                                                         {
//                                                                             border: 0,
//                                                                         },
//                                                                         "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                                                                         {
//                                                                             border: 0,
//                                                                         },
//                                                                     }}
//                                                                     renderValue={(selected) => (
//                                                                         <div className="dial-code-wrapper">
//                                                                             <img src={selected.flag} />
//                                                                             {'+' + selected.dial_code}
//                                                                         </div>
//                                                                     )}
//                                                                     defaultValue={GLOBAL_COUNTRY_CODE}
//                                                                     {...register("country_code", { required: true })}
//                                                                     error={getValues()['mobile_number'] && errors.country_code?.type}
//                                                                 >
//                                                                     {countryCode.map((code, index) =>
//                                                                         <MenuItem className="dial-code-wrapper" value={code}>
//                                                                             <img src={code.flag} />
//                                                                             {'+' + code.dial_code}
//                                                                         </MenuItem>
//                                                                     )}
//                                                                 </Select>
//                                                             </InputAdornment>,
//                                                         }}
//                                                     />
//                                                 )}
//                                             />
//                                             <span className="error-text">
//                                                 {(errors.mobile_number?.type === "required" && (
//                                                     'Mobile number is mandatory'
//                                                 ) || errors.mobile_number?.type === "maxLength" && (
//                                                     'Mobile number must be 10 digit in length'
//                                                 ) || errors.mobile_number?.type === "minLength" && (
//                                                     'Mobile number must be 10 digit in length'
//                                                 ))}
//                                                 {/* {getValues()['mobile_number'] && errors.country_code?.type === "required" && (
//                                         'Country code is required'
//                                     )} */}
//                                             </span>
//                                         </FormControl>
//                                         <FormControl className='form-control'>
//                                             <TextField
//                                                 margin="dense"
//                                                 id="password"
//                                                 placeholder="Password"
//                                                 type="password"
//                                                 fullWidth
//                                                 variant="outlined"
//                                                 size="small"
//                                                 InputLabelProps={{ shrink: false }}
//                                                 {...register("password", { required: true, minLength: 6, maxLength: 20 })}
//                                                 error={errors.password?.type}
//                                                 helperText={(errors.password?.type === "required" && (
//                                                     'Password is required'
//                                                 ) || errors.password?.type === "minLength" && (
//                                                     'Password should be atleast 6 character in length'
//                                                 ) || errors.password?.type === "maxLength" && (
//                                                     'Password should not be more than 20 character in length'
//                                                 ))}
//                                             />
//                                         </FormControl>
//                                     </div>
//                                 </div>
//                                 <DialogActions className='dialog-action-wrapper'>
//                                     {DialogAction}
//                                 </DialogActions>
//                             </form>}

//                         <h4 type='button' className='link-wrapper-underLine' onClick={() => setIsForgotPass(true)} style={{ margin: '20px 40px 5px', fontSize: "14px" }}>Forgot password? </h4>
//                     </div>
//                 ) : <Forgotpassword onBack={() => setIsForgotPass(false)} />}

//             </CustomDialog>
//             <PrivacyPolicy isOpen={isOpenPrivacy} openPrivacyPolicy={openPrivacyPolicy}/>
//             <TermsAndConditions isOpen={isOpenTerms} openTermsAndConditions={openTermsAndConditions}/>
//         </div>
//     );
// }

// import React, { useEffect, useState } from 'react';
// import { useForm, Controller } from "react-hook-form";
// import { useSnackbar } from 'notistack';
// import {
//     TextField,
//     Button,
//     FormControl,
//     DialogActions,
//     InputAdornment,
//     Select,
//     MenuItem,
//     CardMedia,
//     Grid
// } from '@mui/material';
// import { Modal, Box, Typography, IconButton } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import _ from 'lodash';
// import axios from "axios";

// import Loader from 'components/Loader';
// import { countryCode } from 'constants/appData/filters';
// import axiosInstance from "configs/axiosConfig";
// import { APIRouteConstants, dashboardRouteConstants } from "constants/routeConstants";
// import CustomDialog from 'components/Dialog';
// import { handleOpenAuthDialog, updateUserDetail } from 'utils/auth';
// import { API_URL, ENABLED_D6_FEATURE, GLOBAL_COUNTRY_CODE } from 'constants/appConstants'
// import Forgotpassword from 'containers/Forgotpassword';
// import PrivacyPolicy from 'containers/PrivacyPolicy';
// import TermsAndConditions from 'containers/TermsAndConditions';
// import { useAuth } from 'oidc-react';
// import { useSelector } from 'react-redux';

// export default function AuthDialog({ isAuthDialogOpen, setAuthDialog, refreshUser, logoUrl }) {
//     const { register, formState: { errors }, handleSubmit, control, getValues } = useForm({
//         defaultValues: {
//             first_name: '',
//             last_name: '',
//             mobile_number: '',
//             email: '',
//             // password: '',
//             country_code: GLOBAL_COUNTRY_CODE
//         },
//     });
//     const { enqueueSnackbar } = useSnackbar();
//     const [isLoginView, setLoginView] = useState(true);
//     const [loader, setLoader] = useState(false);
//     const [isForgotPass, setIsForgotPass] = useState(false)
//     const [isOpenPrivacy, setOpenPrivacy] = useState(false)
//     const [isOpenTerms, setOpenTerms] = useState(false)
//     const [isD6AuthDialogOpen, setisD6AuthDialogOpen] = useState(false)
//     const [isD6AuthDialog, setD6AuthDialog] = useState(false)

//     const auth = useAuth();
//     const handleLoginView = () => {
//         if (isForgotPass) {
//             setIsForgotPass(false)
//             setLoginView(true)
//         } else {
//             setLoginView(!isLoginView)
//         }
//     }

//     const DialogHeader = (
//         <span className='description'>Please enter your details to {isLoginView ? 'sign in' : 'get started'}.</span>
//     );

//     const DialogAction = (
//         <Button type="submit" color="success" variant="contained">
//             {isLoginView ? 'Sign in' : 'Sign up'}
//         </Button>
//     )

//     const DialogFooter = (
//         <div style={{ textAlign: 'center' }} className='link-wrapper'>
//             <u onClick={handleLoginView}>
//                 <p className="decorated-text description">
//                     {isLoginView && !isForgotPass ?
//                         `Don't have an account? Create account` :
//                         `Already an existing user? Sign in`}
//                 </p>
//             </u>
//         </div>
//     )

//     const privacyStatement = (
//         <div style={{ textAlign: 'center', padding: '0.6rem 2rem' }} className=' link-wrapper'>
//             <u>
//                 <p style={{ fontSize: '15px', }} className="description">
//                     By continuing, you agree to the
//                     <span
//                         className='link-wrapper-underLine'
//                         onClick={() => setOpenTerms(true)}>
//                     {" "} Terms of Service
//                     </span> and  <span
//                     onClick={(e) => {
//                         setOpenPrivacy(true)
//                     }} className='link-wrapper-underLine'>Privacy Policy.</span>
//                 </p>
//             </u>
//         </div>
//     )

//     const getUser = async (token) => {
//         let res = await axios.get(APIRouteConstants.AUTH.ME, {
//             baseURL: API_URL,
//             headers: {
//                 Accept: "application/json",
//                 "domain-name": 'accessories',
//                 Authorization: `Bearer ${token}`,
//             }
//         })
//         let { data, response } = res;

//         if (response
//             && response.status === 401) {
//             // navigate(authRouteConstants.LOGOUT)
//         }

//         if (data && data.success) {
//             const user = data.data;
//             updateUserDetail(user)
//             handleOpenAuthDialog()
//             setLoader(false)
//         }
//     }

//     const doLogin = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.LOGIN, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data) {
//             if (response.data.message) {
//                 enqueueSnackbar(response.data.message, { variant: 'error' });
//                 setLoader(false)
//             } else
//                 for (let i in response.data) {
//                     enqueueSnackbar(response.data[i][0], { variant: 'error' });
//                     setLoader(false)
//                 }
//         }

//         if (data && data.success) {
//             localStorage.setItem('u-access-token', data.access)
//             localStorage.setItem('u-refresh-token', data.access)
//             getUser(data.access)
//         }
//     }

//     const doCreateUser = async (formData) => {
//         setLoader(true)
//         let res = await axiosInstance.post(APIRouteConstants.AUTH.SIGNUP, formData)
//         let { data, response } = res;

//         if (response
//             && response.status === 400
//             && response.data ) {
//                 if (response.data.message) {
//                     enqueueSnackbar(response.data.message, { variant: 'error' })
//                 } else {
//                     for (let i in response.data) {
//                         enqueueSnackbar(_.capitalize(i) + ': ' + response.data[i][0], { variant: 'error' });
//                     }
//                 }
//         }

//         // if (!_.isEmpty(data)) {
//         //     setLoginView(true)
//         // }
//       if (data && data.success) {
//         localStorage.setItem('u-access-token', data.access)
//         localStorage.setItem('u-refresh-token', data.refresh)
//         console.log("datafast", data)
//         if (data.message) { enqueueSnackbar(data.message, { variant: 'success' }) }
//         getUser(data.access)
//       }
//       setLoader(false)
//     }

//     const handleAuth = (formData) => {
//         if (isLoginView) doLogin(formData)
//         else {
//             if (formData.mobile_number) {
//                 formData = {
//                     ...formData,
//                     country_code: formData.country_code.dial_code,
//                 }
//             } else {
//                 delete formData['mobile_number']
//                 delete formData['country_code']
//             }
//             doCreateUser(formData)
//         }
//     }

//     const openTermsAndConditions = (value) => {
//         setOpenTerms(value);
//     }

//     const openPrivacyPolicy = (value) => {
//         setOpenPrivacy(value);
//     }

//     const handleLoginD6=()=>{

//     auth.signIn(); // Trigger login flow only when the button is clicked

//         // setisD6AuthDialogOpen(!isD6AuthDialogOpen)
//     }
//     const handleLoginD6Close=()=>{
//         setisD6AuthDialogOpen(!isD6AuthDialogOpen)
//     }

//      const IS_D6_APP= ENABLED_D6_FEATURE.includes(window?.location?.host)
//     return (
//       <div>
//           {/* {isD6AuthDialogOpen && <D6Modal
//             logoUrl={logoUrl}
//             isDialogOpen={isD6AuthDialogOpen}
//             setDialogOpen1={handleLoginD6Close}
//           />} */}
//           <CustomDialog
//             isDialogOpen={isAuthDialogOpen}
//             setDialogOpen={setAuthDialog}
//             header={!isForgotPass && DialogHeader}
//             footer={DialogFooter}
//             isFormattedDialog={!isForgotPass}
//             action={DialogAction}
//             handleForm={handleAuth}
//             logoUrl={logoUrl}
//             subFooter={!isForgotPass && privacyStatement}
//           >
//             <Loader open={loader} />
//             {!isForgotPass ? (
//               <div>
//                 {isLoginView ? (
//                   <form onSubmit={handleSubmit(handleAuth)}>
//                     <div className="dialog-body">
//                       <div className="auth-wrapper form-wrapper">
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="email"
//                             placeholder="Email"
//                             type="email"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("email", { required: true })}
//                             error={errors.email?.type}
//                             helperText={
//                               errors.email?.type === "required" &&
//                               "Email or Phone number is required"
//                             }
//                           />
//                         </FormControl>
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="name"
//                             placeholder="Enter Password"
//                             type="password"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             // label="Password"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("password", { required: true })}
//                             error={errors.password?.type}
//                             helperText={
//                               errors.password?.type === "required" &&
//                               "Password is required"
//                             }
//                           />
//                         </FormControl>
//                       </div>
//                     </div>
//                     <DialogActions className="dialog-action-wrapper">
//                       {DialogAction}
//                     </DialogActions>
//                     {IS_D6_APP && (
//                       <Grid
//                         item
//                         xs={12}
//                         textAlign={"center"}
//                         sx={{ width: "90%", margin: "auto", mt: 2 }}
//                       >
//                         <Button
//                           variant="contained"
//                           onClick={handleLoginD6}
//                           sx={{ width: "96%", textTransform: "none" }}
//                         >
//                           Login with d6
//                         </Button>
//                       </Grid>
//                     )}
//                   </form>
//                 ) : (
//                   <form onSubmit={handleSubmit(handleAuth)}>
//                     <div className="dialog-body">
//                       <div className="auth-wrapper form-wrapper">
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="first_name"
//                             placeholder="First Name"
//                             type="text"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("first_name", {
//                               required: true,
//                               maxLength: 20,
//                             })}
//                             error={errors.first_name?.type}
//                             helperText={
//                               errors.first_name?.type === "required" &&
//                               "First name is required"
//                             }
//                           />
//                         </FormControl>
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="last_name"
//                             placeholder="Last Name"
//                             type="text"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("last_name", {
//                               required: true,
//                               maxLength: 20,
//                             })}
//                             error={errors.last_name?.type}
//                             helperText={
//                               errors.last_name?.type === "required" &&
//                               "Last name is required"
//                             }
//                           />
//                         </FormControl>
//                         <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="email"
//                             placeholder="Email"
//                             type="email"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("email", {
//                               required: true,
//                               pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i,
//                             })}
//                             error={errors.email?.type}
//                             helperText={
//                               (errors.email?.type === "required" &&
//                                 "Email is required") ||
//                               (errors.email?.type === "pattern" &&
//                                 "Email is invalid")
//                             }
//                           />
//                         </FormControl>
//                         <FormControl fullWidth className="select-wrapper">
//                           <Controller
//                             control={control}
//                             name="mobile_number"
//                             rules={{
//                               required: true,
//                               maxLength: 10,
//                               minLength: 10,
//                             }}
//                             // defaultValue={contact?.mobile_number}
//                             render={({ field: { onChange, value } }) => (
//                               <TextField
//                                 margin="dense"
//                                 id="name"
//                                 placeholder="Mobile Number"
//                                 type="text"
//                                 fullWidth
//                                 variant="outlined"
//                                 size="small"
//                                 onChange={onChange}
//                                 value={value}
//                                 autoComplete="false"
//                                 InputLabelProps={{ shrink: false }}
//                                 InputProps={{
//                                   startAdornment: (
//                                     <InputAdornment position="start">
//                                       <Select
//                                         labelId="demo-simple-select-label"
//                                         id="demo-simple-select"
//                                         className="select-input"
//                                         label="Status"
//                                         size="small"
//                                         fullWidth
//                                         sx={{
//                                           ".MuiOutlinedInput-notchedOutline": {
//                                             border: 0,
//                                           },
//                                           "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
//                                             {
//                                               border: 0,
//                                             },
//                                           "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//                                             {
//                                               border: 0,
//                                             },
//                                         }}
//                                         renderValue={(selected) => (
//                                           <div className="dial-code-wrapper">
//                                             <img src={selected.flag} />
//                                             {"+" + selected.dial_code}
//                                           </div>
//                                         )}
//                                         defaultValue={GLOBAL_COUNTRY_CODE}
//                                         {...register("country_code", {
//                                           required: true,
//                                         })}
//                                         error={
//                                           getValues()["mobile_number"] &&
//                                           errors.country_code?.type
//                                         }
//                                       >
//                                         {countryCode.map((code, index) => (
//                                           <MenuItem
//                                             className="dial-code-wrapper"
//                                             value={code}
//                                           >
//                                             <img src={code.flag} />
//                                             {"+" + code.dial_code}
//                                           </MenuItem>
//                                         ))}
//                                       </Select>
//                                     </InputAdornment>
//                                   ),
//                                 }}
//                               />
//                             )}
//                           />
//                           <span className="error-text">
//                             {(errors.mobile_number?.type === "required" &&
//                               "Mobile number is mandatory") ||
//                               (errors.mobile_number?.type === "maxLength" &&
//                                 "Mobile number must be 10 digit in length") ||
//                               (errors.mobile_number?.type === "minLength" &&
//                                 "Mobile number must be 10 digit in length")}
//                             {/* {getValues()['mobile_number'] && errors.country_code?.type === "required" && (
//                                         'Country code is required'
//                                     )} */}
//                           </span>
//                         </FormControl>
//                         {/* <FormControl className="form-control">
//                           <TextField
//                             margin="dense"
//                             id="password"
//                             placeholder="Password"
//                             type="password"
//                             fullWidth
//                             variant="outlined"
//                             size="small"
//                             InputLabelProps={{ shrink: false }}
//                             {...register("password", {
//                               required: true,
//                               minLength: 6,
//                               maxLength: 20,
//                             })}
//                             error={errors.password?.type}
//                             helperText={
//                               (errors.password?.type === "required" &&
//                                 "Password is required") ||
//                               (errors.password?.type === "minLength" &&
//                                 "Password should be atleast 6 character in length") ||
//                               (errors.password?.type === "maxLength" &&
//                                 "Password should not be more than 20 character in length")
//                             }
//                           />
//                         </FormControl> */}
//                       </div>
//                     </div>
//                     <DialogActions className="dialog-action-wrapper">
//                       {DialogAction}
//                     </DialogActions>
//                   </form>
//                 )}

//                 <h4
//                   type="button"
//                   className="link-wrapper-underLine"
//                   onClick={() => setIsForgotPass(true)}
//                   style={{ margin: "20px 40px 5px", fontSize: "14px" }}
//                 >
//                   Forgot password?{" "}
//                 </h4>
//               </div>
//             ) : (
//               <Forgotpassword onBack={() => setIsForgotPass(false)} />
//             )}
//           </CustomDialog>

//         <PrivacyPolicy
//           isOpen={isOpenPrivacy}
//           openPrivacyPolicy={openPrivacyPolicy}
//         />
//         <TermsAndConditions
//           isOpen={isOpenTerms}
//           openTermsAndConditions={openTermsAndConditions}
//         />
//       </div>
//     );
// }

// import React, { useState } from "react";
// import { Modal, Box, TextField, Button, Typography, MenuItem, Select, Grid } from "@mui/material";
// import axios from "axios";

// const SignupModal = ({ open, onClose }) => {
//   const [step, setStep] = useState(1);
//   const [countryCode, setCountryCode] = useState("+27");
//   const [mobile, setMobile] = useState("");
//   const [userData, setUserData] = useState({ firstName: "", lastName: "", email: "" });
//   const [otp, setOtp] = useState("");
//   const [isRegistered, setIsRegistered] = useState(false);
//   const [errors, setErrors] = useState({});

//   const validateMobile = () => /^[0-9]{9}$/.test(mobile);
//   const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

//   const handleback = () => {
//     if (step === 2) {
//       setStep(1)
//     } else if (step === 3) {
//       setStep(2)
//     }
//   }

//   const handleNext = async () => {
//     let newErrors = {};

//     if (step === 1) {
//       if (!validateMobile()) {
//         newErrors.mobile = "Invalid mobile number. Must be 9 digits.";
//       } else {
//         try {
//           // const response = await axios.post("/api/check-user", { mobile });
//           // setIsRegistered(response.data.registered);
//           // setStep(response.data.registered ? 3 : 2);
//           setStep(2);
//           return;
//         } catch (error) {
//           newErrors.mobile = "Failed to verify mobile number.";
//         }
//       }
//     } else if (step === 2) {
//       if (!validateEmail(userData.email)) newErrors.email = "Invalid email format.";
//       if (!userData.firstName) newErrors.firstName = "First Name is required.";
//       if (!userData.lastName) newErrors.lastName = "Last Name is required.";

//       if (Object.keys(newErrors).length === 0) {
//         try {
//           // await axios.post("/api/register", { ...userData, mobile });
//           setStep(3);
//           return;
//         } catch (error) {
//           newErrors.email = "Registration failed. Try again.";
//         }
//       }
//     } else if (step === 3) {
//       try {
//         // await axios.post("/api/verify-otp", { mobile, otp });
//         onClose();
//         setStep(1)
//         setUserData({ firstName: "", lastName: "", email: "" });
//         setMobile("");
//       } catch (error) {
//         newErrors.otp = "Invalid OTP. Try again.";
//       }
//     }

//     setErrors(newErrors);
//   };

//   return (
//     <Modal open={open}
//       onClose={onClose}
//     >
//       <Box
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: 400,
//           bgcolor: "background.paper",
//           boxShadow: 24,
//           p: 4,
//           borderRadius: 2,
//         }}
//       >
//         {step === 1 && (
//           <>
//            <Grid container spacing={2} alignItems="center"  >
//  <Grid item>

//   <Typography variant="h6">Enter Mobile Number to start your journey</Typography>
//  </Grid>
//   <Grid item xs={3}>
//     <Select
//       fullWidth

//       size="medium"
//       sx={{ fontSize:"0.5rem" }}
//       value={countryCode}
//       onChange={(e) => setCountryCode(e.target.value)}
//     >
//       <MenuItem value={"+27"}>(+27)</MenuItem>
//     </Select>
//   </Grid>

//   {/* Mobile Number TextField */}
//   <Grid item xs={9}>
//     <TextField

//     sx={{ fontSize:"0.8rem" }}
//       fullWidth
//       label="Mobile Number"
//       variant="outlined"
//       size="small"
//       value={mobile}
//       onChange={(e) => setMobile(e.target.value)}
//     />
//   </Grid>
//   <Grid item xs={12}>
//   <Typography texta align="center" sx={{fontSize:"0.8rem", color:"red"}}>
//     {errors.mobile}
//   </Typography>
//   </Grid>
// </Grid>

//           </>
//         )}
//         {step === 2 && (
//           <>
//             <Typography variant="h6">Enter Details</Typography>
//             <TextField
//               fullWidth
//               label="First Name"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               value={userData.firstName}
//               onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
//               error={!!errors.firstName}
//               helperText={errors.firstName}
//             />
//             <TextField
//               fullWidth
//               label="Last Name"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               value={userData.lastName}
//               onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
//               error={!!errors.lastName}
//               helperText={errors.lastName}
//             />
//             <TextField
//               fullWidth
//               label="Email"
//               type="email"
//               variant="outlined"
//               margin="normal"
//               size="small"
//               value={userData.email}
//               onChange={(e) => setUserData({ ...userData, email: e.target.value })}
//               error={!!errors.email}
//               helperText={errors.email}
//             />
//           </>
//         )}
//         {step === 3 && (
//           <>
//             <Typography variant="h6">Verify OTP</Typography>
//             <TextField
//               fullWidth
//               label="OTP"
//               variant="outlined"
//               margin="normal"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               error={!!errors.otp}
//               helperText={errors.otp}
//             />
//           </>
//         )}
//         <Grid item sx={{ display: "flex" }} spacing={2} justifyContent="space-between">
//           <Button variant="contained" size="small" sx={{ mt: 2 }} onClick={handleback}>
//             Back        </Button>
//           <Button variant="contained" size="small" sx={{ mt: 2 }} onClick={handleNext}>
//             {step === 3 ? "Verify & Continue" : "Next"}
//           </Button>
//         </Grid>
//       </Box>
//     </Modal>
//   );
// };

// export default SignupModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Typography,
  MenuItem,
  Select,
  Grid,
  DialogContentText,
  Box,
  CardMedia,
  Divider,
  LinearProgress,
  CircularProgress,
  InputAdornment,
  Avatar,
} from "@mui/material";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { Close } from "@mui/icons-material";
import { useAuth } from "oidc-react";
import {
  API_URL,
  ENABLED_D6_FEATURE,
  GLOBAL_COUNTRY_CODE,
} from "constants/appConstants";
import { useModal } from "utils/SignupContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { customeStyle } from "utils/style";
import instance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { enqueueSnackbar, useSnackbar } from "notistack";
import FullScreenLoader from "Context/FullScreenLoader";
import { updateUserDetail } from "utils/auth";
import _ from "lodash";
import { useCart } from "utils/CartContext";
import { useNavigate } from "react-router-dom";
import { clearCart, getCartItemsFromLocalStorage } from "utils/cart";
import { updateCartCount } from "utils/website";
import MuiResponsivePhoneInput from "./MuiResponsivePhoneInput";
import { isValidInternationalPhoneNumber } from "utils/helper";
import { useStore } from "utils/OfflineContext";
const SignupDialog = ({ websiteInfo }) => {
  const { isOpen, openModal, closeModal, loginMessage } = useModal();
  const [step, setStep] = useState(1);
  const [countryCode, setCountryCode] = useState("27");
  const [mobile, setMobile] = useState("");
  const [useremail, setUseremail] = useState("");
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiErrors] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);
  const {
    messagefroAuth,
    setmessagefroAuth,
    couponctx,
    orderNotesctx,
    updateCouponctx,
    saveNotectx,
  } = useCart();
  const { pilotPOSContext, setPilotPOSContext } = useStore();
  const auth = useAuth();
  const navigate = useNavigate();

  const validateMobile = () =>
    isValidInternationalPhoneNumber(`+${mobile?.full}`);
  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  const validateOtp = (otp) => {
    if (!otp) return "OTP is required.";
    if (!/^\d{5}$/.test(otp)) return "OTP must be 5 digits.";
    return "";
  };

  const handleBack = () => {
    if (isRegistered) {
      setStep(1);
    }
    setApiErrors("");
    setErrors({});
    setStep((prev) => Math.max(1, prev - 1));
  };

  const handleLoginD6 = () => {
    auth.signIn();
  };

  console.log("mobile", mobile);
  const checkMobileExist = async () => {
    console.log("mobile", mobile?.dia);

    const payload = {
      mobile_number: mobile?.number,
      country_code: mobile?.dialCode,
    };

    // return
    try {
      setLoading(true);
      const Response = await instance.post(
        APIRouteConstants.AUTH.MOBILE_CHECK,
        { ...payload },
      );

      setLoading(false);
      return Response?.data;
    } catch (error) {
      console.log(error);
    }
  };
  const getUserDetails = async (category) => {
    // setLoader(true)
    let res = await instance.get(APIRouteConstants.AUTH.ME);
    let { data } = res;

    console.log("user", data);
    if (data && !_.isEmpty(data)) {
      localStorage.setItem("u_user_data", JSON.stringify(data));
      updateUserDetail(data.data);
    }
    // setLoader(false)
  };

  const createUser = async () => {
    const payload = {
      mobile_number: mobile?.number,
      country_code: mobile?.dialCode,
      last_name: userData.lastName,
      first_name: userData.firstName,
      email: userData.email,
    };
    try {
      setLoading(true);

      setApiErrors("");
      const Response = await instance.post(APIRouteConstants.AUTH.CREATE_USER, {
        ...payload,
      });
      if (Response.status === 400) {
        const mobile = Response?.response?.data?.existing_mobile_number;
        setApiErrors(
          `It looks like this email is already in use with the mobile number ${mobile}. Please try using a different one!`,
        );
        setLoading(false);
        // enqueueSnackbar("This email ID is already registered. Try another.", { variant: "error" });
        return false;
      }
      if (Response.status === 201) {
        setLoading(false);

        return Response.message;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const verifyOTP = async () => {
    const payload = {
      mobile_number: mobile?.number,
      country_code: mobile?.dialCode,
      otp: otp,
    };
    try {
      setLoading(true);
      setApiErrors("");
      const Response = await instance.post(APIRouteConstants.AUTH.VERIFY_OTP, {
        ...payload,
      });
      if (Response.status === 400) {
        setLoading(false);
        setApiErrors(
          Response?.response?.data?.error != undefined &&
            Response?.response?.data?.error,
        );
        return Response?.response?.data?.error;
      }
      if (Response.status === 200) {
        setLoading(false);
        return Response;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleNext = async () => {
    setErrors({});
    let newErrors = {};
    if (step === 1) {
      if (!validateMobile()) {
        newErrors.mobile = "Invalid mobile number.";
      } else {
        const Checkuser = await checkMobileExist();
        if (Checkuser?.is_registered) {
          setIsRegistered(Checkuser?.is_registered);
          setUseremail(Checkuser?.email);
          setStep(3);
        } else {
          setIsRegistered(false);
          setStep(2);
        }

        return;
      }
    } else if (step === 2) {
      if (!validateEmail(userData.email))
        newErrors.email = "Invalid email format.";
      if (!userData.firstName) newErrors.firstName = "First Name is required.";
      if (!userData.lastName) newErrors.lastName = "Last Name is required.";

      if (Object.keys(newErrors).length === 0) {
        const response = await createUser();
        if (response === false) {
          return;
        } else {
          // alert(`${response}`)
          setStep(3);
        }
        return;
      }
    } else if (step === 3) {
      const otpError = validateOtp(otp);
      if (otpError) {
        setErrors({ otp: otpError });
        return;
      }
      const response = await verifyOTP();
      if (
        response ===
        "Invalid OTP. Please re-enter the correct code and try again."
      ) {
        // alert(`${response}`)
      } else if (response && response?.data && response?.data?.access) {
        localStorage.setItem("u-access-token", response?.data?.access);
        localStorage.setItem("u-refresh-token", response?.data?.refresh);
        closeModal();
        setUserData({ firstName: "", lastName: "", email: "" });
        setMobile("");
        setStep(1);
        setOtp("");
        if (window.location.pathname === "/cart") {
          syncCartFromLocalStorage();
        } else {
          window.location.reload();
        }
      }
    }

    setErrors(newErrors);
  };

  const checkoutCart = async () => {
    setLoading(true);
    let formData = {};
    try {
      // Retrieve table number from localStorage
      const tableNumber = localStorage.getItem("number");
      console.log("Number before checkout:", tableNumber);

      if (tableNumber) {
        formData["number"] = tableNumber;
      }
      const notesFromLocal = localStorage.getItem("localNotes");
      if (notesFromLocal) {
        const parsedNotes = JSON.parse(notesFromLocal);
        if (Array.isArray(parsedNotes) && parsedNotes.length > 0) {
          formData["products"] = parsedNotes;
        }
      }
      if (couponctx) formData["voucher_code"] = couponctx;

      if (pilotPOSContext === true) {
        formData["is_pilot_order"] = pilotPOSContext;
      }

      // The tip is selected on the cart before login and kept in localStorage.
      // This auto-checkout path (triggered right after OTP verify) must forward
      // it, otherwise the order is created without the tip the user chose.
      const tipFromLocal = Number(localStorage.getItem("tip_amount")) || 0;
      if (tipFromLocal > 0) {
        formData["tip_amount"] = tipFromLocal;
      }

      let res = await instance.post(
        APIRouteConstants.DASHBOARD.CHECKOUT,
        formData,
      );
      let { data, response } = res;

      // if (response && response.status == 400) {
      //   // enqueueSnackbar(response?.data?.detail ||'coupon not valid.', { variant: 'error' });
      //   setmessagefroAuth(response?.data?.detail ||'coupon not valid.')

      //           localStorage.removeItem("vouchercode")
      //   setLoading(false)

      // }

      if (res.status === 400 || res.status === 404) {
        console.log(res, "RESPONSEEEEEE");
        if (res.response.data.error === "Invalid sequence number") {
          enqueueSnackbar("Invalid QR code, Please try again.", {
            variant: "error",
          });
          setLoading(false);
          return;
        }
        if (
          res.response.data.error === "Order note is required for all products."
        ) {
          enqueueSnackbar("Order note is required for all products.", {
            variant: "error",
          });
          setLoading(false);
          return;
        }
        if (couponctx) {
          console.log(res, "RESPONSEEEEEE");
          setmessagefroAuth(
            res.data?.detail ||
              res?.response?.data?.detail ||
              res.data?.message ||
              "Voucher not found with the specified code or not valid.",
          );
          updateCouponctx("");
          localStorage.removeItem("vouchercode");
          setLoading(false);
          return;
        }
        if (websiteInfo?.order_note_required) {
          enqueueSnackbar(res?.response?.data?.error, { variant: "error" });
          setLoading(false);
          return;
        }
        enqueueSnackbar(
          "There is some issue while checkout, Please try again..",
          { variant: "error" },
        );
        setLoading(false);
        return;
      }

      // If checkout is successful, navigate to checkout page

      if (
        res?.data?.pilot_response != null &&
        res?.data?.pilot_response?.response?.Status === true
      ) {
        console.log(
          "object",
          res?.data?.pilot_response != null &&
            res?.data?.pilot_response?.response?.Status === true,
        );
        enqueueSnackbar("Order sent to Pilot POS successfully.", {
          variant: "success",
        });
        navigate(`/order-status?orderid=${res?.data?.transaction_id}`, {
          state: { order: res?.data },
        });
        // setTimeout(() => {
        //     window.location.reload();
        // }, 300);
      } else if (res.data && res.data.transaction_id) {
        navigate("/checkout", {
          state: { orderId: res?.data?.transaction_id },
        });
      }
      // if (res.data && res.data.transaction_id) {
      //   navigate("/checkout", { state: { orderId: res.data.transaction_id } });
      //   localStorage.removeItem("localNotes"); // Clear saved notes after checkout
      //   saveNotectx();
      // }
    } catch (error) {
      console.error("❌ Checkout error:", error);
      setmessagefroAuth("An error occurred while processing your checkout.");
    }

    setLoading(false);
  };

  const syncCartFromLocalStorage = async () => {
    setLoading(true);
    let cartItems = getCartItemsFromLocalStorage();
    cartItems = _.map(cartItems, (product) => ({
      product: product.id,
      quantity: product.quantity,
    }));
    let res = await instance.post(
      APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS_LOCAL_STORAGE,
      cartItems,
    );
    let { data, response } = res;
    console.log("status", typeof res.status);
    if (res?.status === 201) {
      checkoutCart();
      clearCart();
      updateCartCount(true);
    }
  };

  useEffect(() => {
    setUserData({ firstName: "", lastName: "", email: "" });
    setMobile("");
    setStep(1);
    setOtp("");
    setApiErrors("");
  }, [isOpen]);

  const IS_D6_APP = ENABLED_D6_FEATURE.includes(window?.location?.host);
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return; // Prevent closing on backdrop click
          closeModal();
        }}
        fullScreen={false}
        sx={{
          width: { lg: "40%", md: "50%", sm: "70%", xs: "95%" },
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiPaper-root": {
            borderRadius: "0.1rem", // Adjust the border-radius
          },
        }}
      >
        {
          <>
            <Grid
              p={1}
              sx={{
                background: "#f7f7f7",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid display={"flex"} alignItems={"center"}>
                <CardMedia
                  sx={{
                    width: { lg: "18%", md: "18%", sm: "25%", xs: "25%" },
                    objectFit: "contain",
                    px: 2,
                  }}
                  component={"img"}
                  src={websiteInfo && websiteInfo.websiteInfo.logo}
                />
                <Typography
                  variant="h6 "
                  pb={0}
                  sx={{ textTransform: "capitalize" }}
                >
                  {websiteInfo && websiteInfo.websiteInfo.store_name}
                </Typography>
              </Grid>
              <Grid>
                <Close sx={{ cursor: "pointer" }} onClick={closeModal} />
              </Grid>
            </Grid>
            {loginMessage && (
              <Box
                sx={{
                  background: "#f9f9f9",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  p: 1.5,
                  mx: 3,
                  mt: 3,
                }}
              >
                <Typography
                  sx={{
                    color: "#000",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  🔒 {loginMessage}
                </Typography>
              </Box>
            )}
            {apiError && (
              <Grid textAlign={"center"} px={2}>
                <Typography
                  sx={{ fontSize: customeStyle.typography.subhading1 }}
                  color={"red"}
                >
                  {apiError}
                </Typography>
              </Grid>
            )}
            {loading ? (
              <Box
                height={"35vh"}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {" "}
                <CircularProgress size={24} color="secondary" />{" "}
              </Box>
            ) : (
              <>
                <DialogTitle
                  variant="body2"
                  sx={{
                    px: 3,
                    pb: 0,
                    // mt: 1,
                    // fontSize: customeStyle.typography.subhading,
                    // color: customeStyle.errorColor,
                    fontWeight: "500",
                    // fontSize: customeStyle.typography.subhading1,
                  }}
                >
                  {step === 1
                    ? `${IS_D6_APP ? "Login with d6 or create a profile" : "Create a profile"}`
                    : step === 2
                      ? "Let's get your profile set up!"
                      : `We've sent an OTP to your email - ${userData?.email || useremail}`}
                </DialogTitle>
                <DialogTitle
                  sx={{
                    px: 3,
                    pt: 0,
                    pb: 0,
                    fontSize: customeStyle.typography.subhading1,
                    color: customeStyle.fadedGrey,
                    // mt: 1,
                  }}
                >
                  {step === 1
                    ? "Please enter your mobile number to receive an OTP for account creation."
                    : step === 2
                      ? "Just enter the details below to complete it."
                      : `Please enter it to verify your email address.`}
                </DialogTitle>

                <Grid>
                  <DialogContent sx={{ px: 0 }}>
                    <Grid>
                      {/* {step === 1 && (
                          <Grid  container spacing={2} alignItems="center" justifyContent={"space-between"} pl={2} mt={0.5} >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                              
                            <MuiResponsivePhoneInput setMobile={setMobile}/>
                            </Grid>
                            {errors.mobile &&
                              <Grid textAlign={'center'} lg={12} md={12} xs={12} mt={1}>
                                <Typography textAlign={'center'} color="error" fontSize={{ xs: "0.7rem", sm: "0.7rem", md: "0.7rem", lg: "0.7rem" }}>{errors.mobile}</Typography>
                              </Grid>
                            }
                          </Grid>
                        )} */}
                      <>
                        {step === 1 && (
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            justifyContent="space-between"
                            px={3}
                          >
                            <Grid item xs={12}>
                              <MuiResponsivePhoneInput setMobile={setMobile} />
                            </Grid>

                            {errors.mobile && (
                              <Grid item textAlign="center" xs={12} mt={1}>
                                <Typography
                                  textAlign="center"
                                  color="error"
                                  fontSize={{
                                    xs: "0.7rem",
                                    sm: "0.7rem",
                                    md: "0.7rem",
                                    lg: "0.7rem",
                                  }}
                                >
                                  {errors.mobile}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        )}
                      </>
                    </Grid>
                    <Grid>
                      {step === 2 && (
                        <Grid sx={{ px: 3 }}>
                          <TextField
                            fullWidth
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: "0.8rem",
                              },
                              "& .MuiInputLabel-shrink": {
                                fontSize: "1rem",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "0.85rem", // 👈 input text size reduced
                              },
                            }}
                            InputProps={{
                              sx: { fontSize: "1rem", height: "2rem" },
                            }}
                            label="First Name"
                            variant="outlined"
                            margin="normal"
                            size="small"
                            value={userData.firstName}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                firstName: e.target.value,
                              })
                            }
                            error={!!errors.firstName}
                            helperText={errors.firstName}
                          />
                          <TextField
                            fullWidth
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: "0.8rem",
                              },
                              "& .MuiInputLabel-shrink": {
                                fontSize: "1rem",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "16px", // 16px minimum prevents iOS Safari auto-zoom
                              },
                            }}
                            label="Last Name"
                            variant="outlined"
                            margin="normal"
                            size="small"
                            value={userData.lastName}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                lastName: e.target.value,
                              })
                            }
                            error={!!errors.lastName}
                            helperText={errors.lastName}
                          />
                          <TextField
                            fullWidth
                            sx={{
                              "& .MuiInputLabel-root": {
                                fontSize: "0.8rem",
                              },
                              "& .MuiInputLabel-shrink": {
                                fontSize: "1rem",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "16px", // 16px minimum prevents iOS Safari auto-zoom
                              },
                            }}
                            label="Email"
                            type="email"
                            variant="outlined"
                            margin="normal"
                            size="small"
                            value={userData.email}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                email: e.target.value,
                              })
                            }
                            error={!!errors.email}
                            helperText={errors.email}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid sx={{ px: 3 }}>
                      {step === 3 && (
                        <TextField
                          fullWidth
                          label="OTP"
                          sx={{
                            "& .MuiInputLabel-root": {
                              fontSize: "0.8rem",
                            },
                            "& .MuiInputLabel-shrink": {
                              fontSize: "1rem",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "16px", // 16px minimum prevents iOS Safari auto-zoom
                            },
                          }}
                          size="small"
                          variant="outlined"
                          margin="normal"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          error={!!errors.otp}
                          helperText={errors.otp}
                        />
                      )}
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      justifyContent="center"
                      mt={0}
                      px={0}
                    >
                      <Grid item>
                        {step !== 1 && (
                          <Button
                            sx={{
                              fontSize: customeStyle.typography.subhading, // Smaller text

                              textTransform: "capitalize",
                            }}
                            variant="contained"
                            size="small"
                            onClick={handleBack}
                            disabled={step === 1}
                          >
                            <ArrowBackIcon
                              sx={{
                                fontSize: customeStyle.typography.subhading,
                              }}
                            />
                            Back
                          </Button>
                        )}
                      </Grid>
                      <Grid item fullWidth>
                        <Button
                          variant="contained"
                          size="small"
                          onClick={handleNext}
                          sx={{
                            fontSize: customeStyle.typography.subhading, // Smaller text
                            textTransform: "capitalize",
                          }}
                        >
                          {/* {step === 3 ? (
                            "Verify"
                          ) : (
                            <ArrowForwardIcon
                              sx={{
                                fontSize: customeStyle.typography.subhading,
                              }}
                            />
                          )} */}

                          {step === 3 ? "Verify" : "Next"}
                          {step !== 3 && (
                            <ArrowForwardIcon
                              sx={{
                                fontSize: customeStyle.typography.subhading,
                              }}
                            />
                          )}
                        </Button>
                      </Grid>
                    </Grid>

                    {IS_D6_APP && step === 1 && (
                      <>
                        <Grid
                          sx={{
                            px: 2,
                            py: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Divider sx={{ flex: 1 }} />
                          <Typography sx={{ mx: 2, fontSize: "0.7rem" }}>
                            Or
                          </Typography>
                          <Divider sx={{ flex: 1 }} />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          textAlign={"center"}
                          sx={{ width: "100%", margin: "auto", mt: 0 }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            onClick={handleLoginD6}
                            sx={{
                              fontSize: customeStyle.typography.subhading, // Smaller text
                              textTransform: "capitalize",
                            }}
                          >
                            Login with d6
                          </Button>
                        </Grid>
                      </>
                    )}
                  </DialogContent>
                </Grid>
              </>
            )}
          </>
        }
      </Dialog>
    </>
  );
};

export default SignupDialog;
